import { mergeJson } from '../../helper/merge-json/merge-json';

export const extendConfigs = (configs) => {
  Object.keys(configs).forEach((id) => {
    const config = configs[id];
    if (config.baseId) {
      const baseConfig = configs[config.baseId];
      if (!baseConfig) {
        throw new Error(`Base config '${config.baseId}' was not found for page ${id}`);
      }

      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      const mergeConfig = mergeJson({}, baseConfig, config) as any;
      configs[id] = mergeConfig;
    }
  });
};
